var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTreeMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19,14v-2.5h-6.5V10h4V1h-9v9h4v1.5H5V14H1v9h9v-9H6v-1.5h12V14h-4v9h9v-9H19z M9,15v7H2v-7H9z M8.5,9V2h7v7H8.5z M22,22 h-7v-7h7V22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTreeMap);
export default __webpack_public_path__ + "static/media/icon-tree-map.44b7066192eecef6794e67162ac3c69e.svg";
export { ForwardRef as ReactComponent };